<template>
  <div class="item-box-content">
    <div class="title-font-style" v-if="contractOverview.signState===1">
      <span>账期设置</span>
    </div>
    <div class="title-font-style" v-else style="margin-bottom:20px">
      <span>账期设置</span>
    </div>
    <div class="config-instruction" style="margin:0" v-if="contractOverview.signState===1">
      <i class="el-icon-warning-outline" style="padding:0"></i>
      说明：
      <span
        v-show="payType===1"
      >约定账期合同无法设置预付款和质保金，可设置约定条件，到达结算日期结算合同中所有已发货产品合同报价，计为已到期账款；合同签订后不得修改付款方式及各阶段金额；</span>
      <span v-show="payType!==1">
        设置预付款后，预付款全额到账后方可允许备货；
        <span v-show="payType===2">货款全额到账后方可允许发货；</span>
        <span v-show="payType!==2">发货后，货款计为已到期款项；</span>
        设置质保金后，自发货之日起计算质保期，质保期结束后，质保金计为已到期款项
        合同签订后不得修改付款方式及各阶段金额；
      </span>
    </div>
    <el-form>
      <el-row>
        <el-col :span="6">
          <el-form-item label="合同金额：" label-width="95px">{{contractTotal | priceFilter}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="付款类型：" label-width="95px">
            <el-select v-if="contractOverview.signState===1" v-model="payType" @change="onChange">
              <el-option
                v-for="(item,index) in paymentTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span v-else>{{payType|payTypeFilters}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="overflow-ellipsis">
          <el-form-item label="补充说明：" label-width="95px">
            <el-input v-if="contractOverview.signState===1" v-model="params.replenMark"></el-input>
            <span v-else class="wp100" >
              <el-tooltip
                :content="contractOverview.replenMark"
                class="overflow-ellipsis"
                effect="dark"
                placement="top"
              >
                <span style="width: 100%">{{contractOverview.replenMark}}</span>
              </el-tooltip>
            </span>
          </el-form-item>
        </el-col>
        <el-col
          :span="6"
          style="text-align:right;"
          v-show="payType!==1&&contractOverview.signState===1"
        >
          <el-form-item>
            <el-button
              @click="addAdvance"
              type="primary"
              :disabled="Boolean(params.isAdvance)"
              plain
            >添加预付款</el-button>
            <el-button
              @click="addQuaGuaDep"
              type="primary"
              :disabled="Boolean(params.isGuarantee)"
              plain
            >添加质保金</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="约定条件：" label-width="95px" v-show="payType===1">
        <el-row :gutter="10" v-if="contractOverview.signState===1">
          <el-col :span="4">
            <el-select placeholder="请选择" v-model="orderContractAppointmentParams.appointType">
              <el-option
                v-for="(item,index) in agreedConditionsList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input-number
              v-model="orderContractAppointmentParams.appointValue"
              :precision="0"
              :min="1"
              label="请设置约定天数"
              :controls="false"
            ></el-input-number>&nbsp;天
          </el-col>
        </el-row>
        <span v-else>
          <span v-if="orderContractAppointmentParams.appointValue">
            {{orderContractAppointmentParams.appointType===1?'发货后':orderContractAppointmentParams.appointType===2?'发货+开票后':'开票后'}}
            {{orderContractAppointmentParams.appointValue + ' 天'}}
          </span>
        </span>
      </el-form-item>
      <table border v-show="payType!==1" class="table-tr">
        <tr style="background: rgba(246,247,250,1);height: 36px;" class="table-tr-td">
          <td>付款项</td>
          <td>金额</td>
          <td>比例</td>
          <td v-show="contractOverview.signState===1">操作</td>
        </tr>
        <tr style="height: 36px;" v-if="Boolean(params.isAdvance)" class="table-tr-td">
          <td>预付款</td>
          <td>
            <el-input
              @input="onAdvanceAmount"
              v-if="contractOverview.signState===1"
              v-model="params.advanceAmount"
            ></el-input>
            <span v-else>{{params.advanceAmount | priceFilter}}</span>
          </td>
          <td>
            <el-input
              v-if="contractOverview.signState===1"
              style="width:90%;"
              @input="onAdvancePer"
              v-model="params.advanceAmountProportion"
            ></el-input>
            <span v-if="contractOverview.signState===1">%</span>
            <span v-else>{{params.advanceAmountProportion|perCentFilter}}</span>
          </td>
          <td v-show="contractOverview.signState===1">
            <el-button type="text" @click="onDelete(2)">移除</el-button>
          </td>
        </tr>
        <tr style="height: 36px;" class="table-tr-td">
          <td>货款</td>
          <td>{{params.goodAmount | priceFilter}}</td>
          <td v-show="contractOverview.signState===1">{{params.goodAmountProportion}}%</td>
          <td v-show="contractOverview.signState!==1">{{params.goodAmountProportion|perCentFilter}}</td>
          <td v-show="contractOverview.signState===1">-</td>
        </tr>
        <tr style="height: 36px;" v-if="Boolean(params.isGuarantee)" class="table-tr-td">
          <td>
            <div style="display: flex;">
              <div
                v-show="contractOverview.signState===1"
                style="width: 70px;line-height: 28px;"
              >质保金</div>
              <el-select v-if="contractOverview.signState===1" v-model="params.guaranteeTime">
                <el-option
                  v-for="(item,index) in deadlineList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <span v-else>质保金：{{params.guaranteeTime}}</span>
            </div>
          </td>
          <td>
            <el-input
              @input="onGuaranteeAmount"
              v-if="contractOverview.signState===1"
              v-model="params.guaranteeAmount"
            ></el-input>
            <span v-else>{{params.guaranteeAmount | priceFilter}}</span>
          </td>
          <td>
            <el-input
              @input="onGuaranteePer"
              style="width:90%;"
              v-if="contractOverview.signState===1"
              v-model="params.guaranteeAmountProportion"
            ></el-input>
            <span v-if="contractOverview.signState===1">%</span>
            <span v-else>{{params.guaranteeAmountProportion|perCentFilter}}</span>
          </td>
          <td v-show="contractOverview.signState===1">
            <el-button type="text" @click="onDelete(1)">移除</el-button>
          </td>
        </tr>
      </table>
    </el-form>
  </div>
</template>
<script>
import { paymentTypeList, agreedConditionsList, deadlineList } from '../../util/data'
export default {
  props: ['payTypel', 'orderContractAppointment', 'orderContractOtherPayment', 'contractOverview'],
  data() {
    return {
      payType: 1,
      orderContractAppointmentParams: {}, // 约定账期
      params: {
        goodAmount: 0,
        goodAmountProportion: 100, // 货款比例
        isAdvance: 0, // 是否有预付款
        isGuarantee: 0 // 是否有质保金
      }, // 除了约定账期外的付款方式
      list: [], // 添加质保金,添加预付款
      paymentTypeList, // 付款类型
      agreedConditionsList, // 约定条件
      deadlineList, // 质保期限
      contractTotal: 0 // 合同总额
    }
  },
  watch: {
    orderContractOtherPayment: {
      // 除了约定账期外的付款方式
      handler(newVal) {
        if (newVal) {
          this.params = JSON.parse(JSON.stringify(newVal))
          if (this.contractOverview.signState === 1) {
            this.params.advanceAmountProportion = this.params.advanceAmountProportion
              ? (+this.params.advanceAmountProportion * 100).toFixed(2)
              : null
            this.params.goodAmountProportion = (+this.params.goodAmountProportion * 100).toFixed(2)
            this.params.guaranteeAmountProportion = this.params.guaranteeAmountProportion
              ? (+this.params.guaranteeAmountProportion * 100).toFixed(2)
              : null
          }
        }
      },
      deep: true
    },
    contractOverview: {
      // 合同金额
      handler(newVal) {
        if (newVal) {
          this.contractTotal = JSON.parse(JSON.stringify(newVal.contractTotal))
          if (this.contractOverview.signState === 1) {
            this.params.goodAmount = this.contractTotal
          }
        }
      },
      deep: true
    },
    params: {
      handler(val) {
        if (this.contractOverview.signState === 1 && this.contractTotal) {
          val.goodAmount =
            this.contractTotal -
            (val.advanceAmount ? Number(val.advanceAmount) : 0) -
            (val.guaranteeAmount ? Number(val.guaranteeAmount) : 0)
          val.goodAmountProportion = Number((val.goodAmount / this.contractTotal) * 100).toFixed(2)
          this.$emit('getProportion', val.goodAmountProportion, val.goodAmount)
        }
      },
      deep: true
    },
    orderContractAppointment: {
      // 约定账期付款方式
      handler(newVal) {
        if (newVal) {
          this.orderContractAppointmentParams = JSON.parse(JSON.stringify(newVal))
        }
      },
      deep: true
    },
    payTypel: {
      handler(newVal) {
        if (newVal) {
          this.payType = newVal
        }
      },
      deep: true
    }
  },
  methods: {
    // 添加质保金
    addQuaGuaDep() {
      this.params.isGuarantee = 1
    },
    // 添加预付款
    addAdvance() {
      this.params.isAdvance = 1
    },
    // 输入质保金计算货期总额
    onGuaranteeAmount() {
      const total = this.contractTotal // 货期金额
      const { params } = this
      params.guaranteeAmount = params.guaranteeAmount.replace(/[^0-9.]/g, '')
      var obj = this.params
      if (
        Number(obj.guaranteeAmount) >
        total - (obj.advanceAmount ? Number(obj.advanceAmount) : 0)
      ) {
        this.$message.error('输入金额过大')
        delete this.params.guaranteeAmount
        delete this.params.guaranteeAmountProportion
        return
      }
      this.params.guaranteeAmountProportion = Number((obj.guaranteeAmount / total) * 100).toFixed(2)
    },
    // 输入质保金比例计算质保金额,货期金额,比例   guaranteeAmountProportion   // advanceAmountProportion 预付款
    onGuaranteePer() {
      const { params } = this
      params.guaranteeAmountProportion = params.guaranteeAmountProportion.replace(/[^0-9.]/g, '')
      var obj = this.params
      if (
        Number(obj.guaranteeAmountProportion) >
        100 - (obj.advanceAmountProportion ? Number(obj.advanceAmountProportion) : 0)
      ) {
        this.$message.error('输入比例过大')
        delete this.params.guaranteeAmountProportion
        delete this.params.guaranteeAmount
        return
      }
      this.params.guaranteeAmount = Number(
        (this.contractTotal * Number(obj.guaranteeAmountProportion)) / 100
      ).toFixed(2)
    },
    // 输入预付款计算货期总额
    onAdvanceAmount() {
      const total = this.contractTotal // 货期金额  advanceAmount
      const { params } = this
      params.advanceAmount = params.advanceAmount.replace(/[^0-9.]/g, '')
      var obj = this.params
      if (
        Number(obj.advanceAmount) >
        total - (obj.guaranteeAmount ? Number(obj.guaranteeAmount) : 0)
      ) {
        this.$message.error('输入金额过大')
        delete this.params.advanceAmount
        delete this.params.advanceAmountProportion
        return
      }
      this.params.advanceAmountProportion = Number((obj.advanceAmount / total) * 100).toFixed(2)
    },
    // 输入预付款比例计算预付款金额,货款金额,货款比例    guaranteeAmountProportion   // advanceAmountProportion 预付款
    onAdvancePer() {
      var obj = this.params
      const { params } = this
      params.advanceAmountProportion = params.advanceAmountProportion.replace(/[^0-9.]/g, '')
      if (
        Number(obj.advanceAmountProportion) >
        100 - (obj.guaranteeAmountProportion ? Number(obj.guaranteeAmountProportion) : 0)
      ) {
        this.$message.error('输入比例过大')
        delete this.params.advanceAmountProportion
        delete this.params.advanceAmount
        return
      }
      this.params.advanceAmount = Number(
        (this.contractTotal * Number(obj.advanceAmountProportion)) / 100
      ).toFixed(2)
    },
    // 移除
    onDelete(type) {
      if (type === 1) {
        this.params.isGuarantee = 0
        delete this.params.guaranteeAmountProportion
        delete this.params.guaranteeAmount
      } else {
        this.params.isAdvance = 0
        delete this.params.advanceAmountProportion
        delete this.params.advanceAmount
      }
    },
    // 选择付款类型
    onChange() {
      // if (this.payType) {

      // }
      this.$emit('onAlterProduct', this.payType)
    }
  }
}
</script>
<style lang="scss">
.table-tr {
  .table-tr-td {
    td {
      padding: 10px;
    }
  }
  width: 100%;
  border-radius: 4px 4px 0px 0px;
  border: none;
  // cell-padding: 0;
  // cell-spacing: 0;
  border-collapse: collapse;
}
.wp100 {
  width: 100%;
}
</style>
